export default __webpack_public_path__ + "static/media/archive.cf3e72fc.svg";